"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
const Config = {
    ConnectionUrl: "wss://chat.fosh.ml/hubs/chat"
};
exports.Config = Config;
exports.default = Config;
//# sourceMappingURL=Config.js.map